export const textObject = {
    'headerTitleCopy': 'Building Hub',
    'headerBodyCopy': 'Documentation',
    'sectionFilterTitle': 'Section',
    'tagFilterTitle': 'Tag',
    'clearCopy': 'Clear',
    'onErrorCopy': "Something went wrong with loading the data, please try again.",
    'onLoadingCopy': "Loading..",
    'emptyListCopy': 'There are no blocks here - change your filters to display available blocks.'
};